export const FilterElement = {
  filterActivityTypes: 'filterActivityTypes',
  filterActivityUsers: 'filterActivityUsers',
  filterActivityDatePicker: 'filterActivityDatePicker',
  activityTableFilterOther: 'activityTableFilterOther',
  activityTableFilterField: 'activityTableFilterField',
  activityTableFilterFieldGroup: 'activityTableFilterFieldGroup',
  activityTableFilterUsers: 'activityTableFilterUsers',
  activityTableFilterTractors: 'activityTableFilterTractors',
  activityTableFilterEquipments: 'activityTableFilterEquipments',
  activityPhase: 'activityPhase',
  orderColFieldName: 'orderColFieldName',
  orderColGroupName: 'orderColFieldName',
  orderColCrop: 'orderColCrop',
  orderColMixes: 'orderColMixes',
  orderColUsersName: 'orderColUsersName',
  orderColTractorName: 'orderColTractorName',
  orderColEquipmentName: 'orderColEquipmentName',
  orderColMachineActivitiesPresent: 'orderColMachineActivitiesPresent',
  orderColActivityDate: 'orderColActivityDate',
  orderColDone: 'orderColDone',
  orderColType: 'orderColType',
  orderColChecks: 'orderColChecks',
  fieldOrderColFieldName: 'fieldOrderColFieldName',
  fieldOrderColGroupName: 'fieldOrderColGroupName',
  fieldOrderColCrop: 'fieldOrderColCrop',
  fieldOrderColMixes: 'fieldOrderColMixes',
  fieldOrderColUsersName: 'fieldOrderColUsersName',
  fieldOrderColTractorName: 'fieldOrderColTractorName',
  fieldOrderColEquipmentName: 'fieldOrderColEquipmentName',
  fieldOrderColMachineActivitiesPresent: 'fieldOrderColMachineActivitiesPresent',
  fieldOrderColActivityDate: 'fieldOrderColActivityDate',
  fieldOrderColDone: 'fieldOrderColDone',
  fieldOrderColType: 'fieldOrderColType',
  fieldOrderColChecks: 'fieldOrderColChecks',
  filterTags: 'filterTags',
  filterCrop: 'filterCrop',
  filterOther: 'filterOther',
  filterField: 'filterField',
  filterTractor: 'filterTractor',
  filterTool: 'filterTool',
  filterStableActivityTypes: 'filterStableActivityTypes',
  filterStableActivityBox: 'filterStableActivityBox',
  filterFieldCommodity: 'filterFieldCommodity',
  filterOrderMacchinary: 'filterOrderMacchinary',
  filterDepositDatePicker: 'filterDepositDatePicker',
  filterDepositOther: 'filterDepositOther',
  filterDepositTypes: 'filterDepositTypes',
  filterDepositUsers: 'filterDepositUsers',
  filterDeposit: 'filterDeposit',
  filterMovement: 'filterMovement',
  filterFieldCrop: 'filterFieldCrop',
  filterFieldGroup: 'filterFieldGroup',
  filterFieldSupplyChain: 'filterFieldSupplyChain',
  filterFieldSeason: 'filterFieldSeason',
  filterFieldVariety: 'filterFieldVariety',
  filterContainers: 'filterContainers',
  filterSilos: 'filterSilos',
  filterTrench: 'filterTrench',
  filterTanks: 'filterTanks',
  querySearchContainersDetails: 'querySearchContainersDetails',
  querySearchContainersList: 'querySearchContainersList',
  activityStatus: 'activityStatus',
  hideFinishProduct: 'hideFinishProduct',
  filterFieldListCrop: 'filterFieldListCrop',
  filterFieldListGroup: 'filterFieldListGroup',
  filterFieldListSupplyChain: 'filterFieldListSupplyChain',
  filterFieldListSeason: 'filterFieldListSeason',
  filterFieldListVariety: 'filterFieldListVariety',
  queryFieldList: 'query_fieldList',
};
